<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
    <form class="kt-form w-webkit-fill-available" [formGroup]="form">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Assign Leads</h5>
                <span class="modal-x-button" (click)="onCloseDialog()">
                    <i class="fa fa-times" aria-hidden="true"></i>
                </span>
            </div>
            <div class="modal-body">

                <!-- Initial Lead Type -->    
                <div class="col-12 form-group row pr-0">
                    <label class="col-4 col-form-label">Initial Lead Type <span class="text-danger">*</span></label>
                    <input type="text" formControlName="initial_lead_type" class="col-8 form-control" [attr.disabled]="true" [value]="data.leadID.lead_type">
                </div>
    
                <!-- Leads -->
                <div class="col-12 form-group row pr-0">
                    <label class="col-4 col-form-label">Leads <span class="text-danger">*</span><i class="fa fa-info-circle lead-tooltip" placement="bottom" [ngbTooltip]="leadListToolTip" container="body"></i></label>
                    <input type="text" formControlName="lead_ids" class="col-8 form-control" [attr.disabled]="true" [value]="data.leadID.initial_lead_type == 0 ? data.leadID.mobile + ' (' + data.leadID.lead_id + ')' : data.leadID.username + ' (' + data.leadID.id + ')'">
                    <ng-template #leadListToolTip>
                        <div class="text-left">
                            <b>Non Member Lead</b>: Display value = Phone Number (Lead ID).<br><b>Member Lead</b>: Display value = Username (Member ID).
                        </div>
                      </ng-template>
                </div>

                <!-- Telemarketer -->
                <div class="col-12 form-group row pr-0">
                    <label class="col-4 col-form-label">Telemarketer <span class="text-danger">*</span></label>
                    <kt-dropdown-wo-lazyload class="dropdown-maxheight col-8 telemarketer-list" style="padding:0"
                    [form] = 'form'
                    [dropdownList] = 'telemarketerDropdownList'
                    [dropdownSettings] = 'telemarketerDropdownSettings'
                    [formName] = "'telemarketer_id'"
                    [selectionAttributes] = "'id'"
                    [selectedItems] = 'telemarketerSelectedItems'>
                    </kt-dropdown-wo-lazyload>
                </div>
            
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="onCloseDialog()"><i class="fas fa-ban"></i>Close</button>
                <button *ngIf="canAssignLead" class="btn btn-primary btn-icon-sm mr-2" (click)="onSubmit()" type="button" [disabled]="buttonLoading || !form.valid"><i [class]="buttonLoading? 'fas fa-circle-notch fa-spin p-0 mr-2' : 'fas fa-save'"></i>Submit</button>
            </div>
        </div>
    </form>
  </div>
  